'use client';

import { useEffect, useState, useRef } from 'react';
import Image from 'next/image';
import styles from './LoadingScreen.module.css';

interface LoadingScreenProps {
  isLoading: boolean;
}

const LoadingScreen = ({ isLoading }: LoadingScreenProps) => {
  // Track if loading was ever true - don't show loading screen if it never was
  const wasEverLoading = useRef(isLoading);
  const [shouldRender, setShouldRender] = useState(isLoading);

  useEffect(() => {
    if (isLoading) {
      wasEverLoading.current = true;
      setShouldRender(true);
    } else if (wasEverLoading.current) {
      // Only do fade-out if we were actually showing the loading screen
      const timer = setTimeout(() => {
        setShouldRender(false);
      }, 300); // Reduced from 500ms
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  // Don't render if loading was never true
  if (!shouldRender) return null;

  return (
    <div className={`${styles.loadingScreen} ${!isLoading ? styles.fadeOut : ''}`}>
      <div className={styles.logoContainer}>
        <Image
          src="/FULL_W_2048.png"
          alt="Lior Murphy Logo"
          width={400}
          height={150}
          priority
          className={styles.logo}
        />
        <div className={styles.loadingBar}>
          <div className={styles.loadingProgress}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;

